import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"; //see documentation of chartjs

//first make these things register then you can use them
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Chart = ({ arr = [], currency, days }) => {
  const prices = [];
  const date = [];
  // console.log(arr) //6:12:00

  for (let i = 0; i < arr.length; i++) {
    //at 0 index we have time in miliseconds and at 1 we price
    //date.push(arr[i][0]); //if we use this we get this type of data in date: 1683370805438, 1683374404723,etc so we use Date()
    //date.push(new Date(arr[i][0])); // now we get this: Sat May 06 2023 16:30:05 GMT+0530 (India Standard Time),etc...
    // date.push(new Date(arr[i][0]).toLocaleDateString()); //to get only date
    // prices.push(arr[i][1]);
    if (days === "24h") {
      date.push(new Date(arr[i][0]).toLocaleTimeString()); //in24h we will se only time not date
    } else {
      date.push(new Date(arr[i][0]).toLocaleDateString());
    }
    prices.push(arr[i][1]);
  }
  //console.log(date);
  const data = {
    labels: date,
    datasets: [
      {
        label: "price in " +currency,
        data: prices,
        borderColor: "rgb(255,99,132)",
        backgroundColor: "black",
      },
    ],
  };

  return (
    <>
      <Line
        options={{
          responsive: true,
        }}
        data={data}
      />
    </>
  );
};

export default Chart;
